import { render, staticRenderFns } from "./ChallengeBox.vue?vue&type=template&id=0d564c16&scoped=true&"
import script from "./ChallengeBox.vue?vue&type=script&lang=js&"
export * from "./ChallengeBox.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeBox.vue?vue&type=style&index=0&id=0d564c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d564c16",
  null
  
)

export default component.exports